/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.credit.memos.rpc.CreditMemosWithAssociatedObjectsService
 */

export const createRpc = {
  serviceName: 'com.hubspot.credit.memos.rpc.CreditMemosWithAssociatedObjectsService',
  rpcName: 'create',
  auth: 'app',
  fingerprint: 'AF0uEpgAnfiRKbX35GsYJuYO401S2tTj',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createExpectedDraftRpc = {
  serviceName: 'com.hubspot.credit.memos.rpc.CreditMemosWithAssociatedObjectsService',
  rpcName: 'createExpectedDraft',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABBvuA9bt6aqJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createExpectedDraftWithCreateOrUpdateRequestRpc = {
  serviceName: 'com.hubspot.credit.memos.rpc.CreditMemosWithAssociatedObjectsService',
  rpcName: 'createExpectedDraftWithCreateOrUpdateRequest',
  auth: 'app',
  fingerprint: 'AF0uEpgAnfhBvuA9bt6aqJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateRpc = {
  serviceName: 'com.hubspot.credit.memos.rpc.CreditMemosWithAssociatedObjectsService',
  rpcName: 'update',
  auth: 'app',
  fingerprint: 'AF0uEpgAnfiRKbX35GsYJuYO401S2tTj',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const voidsRpc = {
  serviceName: 'com.hubspot.credit.memos.rpc.CreditMemosWithAssociatedObjectsService',
  rpcName: 'voids',
  auth: 'app',
  fingerprint: 'zVUmmqR2sMupgZZjXa79seYO401S2tTj',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCreditMemoWithAssociatedObjectsRpc = {
  serviceName: 'com.hubspot.credit.memos.rpc.CreditMemosWithAssociatedObjectsService',
  rpcName: 'getCreditMemoWithAssociatedObjects',
  auth: 'app',
  fingerprint: 'DWcabdalGvGRKbX35GsYJlWFUhV3WCBg',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};